function getPhoneInventoryCacheKey({
  storeId,
  displayName,
  color,
  storageSize,
}: {
  storeId: string;
  displayName: string;
  color?: string;
  storageSize?: string;
}): string {
  if (!storeId) {
    return '';
  }
  return `product-inventory-${storeId}-${displayName}-${color ?? 'null'}-${
    storageSize ?? 'null'
  }`;
}

export default getPhoneInventoryCacheKey;
